import React from "react";

import { Delete } from "@mui/icons-material";
import { Box, IconButton, MenuItem, Select, Typography } from "@mui/material";

const CsvColumnsAppendTableItem = ({
  table,
  appendableColumns,
  appendableCSVColumns,
  onTableColumnUnSelect,
  onTableColumnSelect,
}) => {
  return (
    <Box
      px={2}
      py={2}
      borderRadius="10px"
      height={{ xs: "auto", sm: "100px" }}
      flexDirection={{ xs: "column", sm: "row" }}
      width="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      bgcolor="#F9F7FB"
      mt="15px"
    >
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems="center"
        flex={1}
        width="100%"
        justifyContent="space-between"
      >
        <Typography
          display={{ xs: "block", sm: "none" }}
          width="100%"
          flex={1}
          fontSize={{ xs: "12px", sm: "18px" }}
          color="#697277"
          fontFamily="Outfit"
          fontWeight={500}
        >
          FILE HEADER
        </Typography>
        <Typography
          width="100%"
          flex={1}
          fontSize={{ xs: "14px", sm: "16px" }}
          fontFamily="Outfit"
          fontWeight={500}
          textTransform="uppercase"
        >
          {table.column}
        </Typography>
        <Typography
          mt={1}
          display={{ xs: "block", sm: "none" }}
          width="100%"
          flex={1}
          fontSize={{ xs: "12px", sm: "18px" }}
          color="#697277"
          fontFamily="Outfit"
          fontWeight={500}
        >
          DATA
        </Typography>
        <Box width="100%" overflow="hidden" flex={1}>
          {table.data.map((d) => (
            <Typography
              key={d}
              color="#303334"
              noWrap
              maxWidth="150px"
              fontSize={{ xs: "12px", sm: "14px" }}
              fontFamily="Outfit"
              textTransform="uppercase"
            >
              {d}
            </Typography>
          ))}
          ...
        </Box>
      </Box>
      {table?.appendedValue ? (
        <Box
          display="flex"
          flex={0.5}
          width={{ xs: "100%", sm: "auto" }}
          alignItems="center"
        >
          <Typography
            textAlign="center"
            flex={0.8}
            fontSize={{ xs: "12px", sm: "15px" }}
          >
            {
              appendableCSVColumns?.find((c) => c?.id === table?.appendedValue)
                ?.label
            }
          </Typography>
          <IconButton onClick={() => onTableColumnUnSelect(table.column)}>
            <Delete sx={{ width: "22px", height: "22px" }} />
          </IconButton>
        </Box>
      ) : (
        <>
          <Typography
            mt={1}
            display={{ xs: "block", sm: "none" }}
            width="100%"
            flex={1}
            fontSize={{ xs: "14px", sm: "20px" }}
            color="#303334"
            fontFamily="Outfit"
            fontWeight={500}
          >
            APPEND FIRST
          </Typography>
          <Select
            onChange={(e) => onTableColumnSelect(table.column, e.target.value)}
            size="small"
            sx={{
              width: { xs: "100%", sm: "auto" },
              flex: 0.5,
              bgcolor: "white",
              textTransform: "uppercase",
              color: "#4E585E",
              fontWeight: 500,
              fontFamily: "Outfit",
            }}
          >
            {appendableColumns
              ?.sort((_, b) => b?.required)
              ?.map((column) => (
                <MenuItem
                  key={column.label}
                  value={column?.id}
                  sx={{ textTransform: "uppercase", fontFamily: "Outfit" }}
                >
                  {column?.label}
                  {column?.required && (
                    <Typography sx={{ ml: 0.5, color: "red" }}>*</Typography>
                  )}
                </MenuItem>
              ))}
          </Select>
        </>
      )}
    </Box>
  );
};
export default CsvColumnsAppendTableItem;
